import script from "./transmission.vue?vue&type=script&setup=true&lang=js"
export * from "./transmission.vue?vue&type=script&setup=true&lang=js"

import "./transmission.vue?vue&type=style&index=0&id=54efe9b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54efe9b9"]])

export default __exports__